import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./authSlice";

// Fetch inquiries (GET method)
export const fetchInquiries = createAsyncThunk(
    "inquiries/fetchInquiries",
    async ({ page = 1, perPage = 10, search = "" }, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get("/admin/website-query-list", {
                params: {
                    page,
                    per_page: perPage,
                    search,
                },
            });

            // Flexible mapping to handle different formats from API response
            const data = res.data?.data || res.data || {};
            const queriesList = data.queries || data.list || data.data || [];
            const totalPages = data.total_pages || 1;
            const currentPage = data.current_page || page;
            const totalRecords = data.total_records || queriesList.length;

            return {
                queries: queriesList,
                currentPage,
                totalPages,
                totalRecords,
            };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Respond to inquiry (POST method)
export const respondToInquiry = createAsyncThunk(
    "inquiries/respondToInquiry",
    async ({ query_id, status = 1, team_response }, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.post("/admin/website-query-respond", {
                query_id,
                status,
                team_response,
            });
            return {
                query_id,
                status,
                team_response,
                response: res.data,
            };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const inquirySlice = createSlice({
    name: "inquiries",
    initialState: {
        list: [],
        loading: false,
        error: null,
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchInquiries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInquiries.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.queries;
                state.currentPage = action.payload.currentPage;
                state.totalPages = action.payload.totalPages;
                state.totalRecords = action.payload.totalRecords;
            })
            .addCase(fetchInquiries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(respondToInquiry.pending, (state) => {
                state.loading = true;
            })
            .addCase(respondToInquiry.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update status & response locally for the responded item
                const itemIndex = state.list.findIndex(
                    (item) => (item.query_id || item.id) === action.payload.query_id
                );
                if (itemIndex !== -1) {
                    state.list[itemIndex].status = action.payload.status;
                    state.list[itemIndex].team_response = action.payload.team_response;
                }
            })
            .addCase(respondToInquiry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default inquirySlice.reducer;
